import React from 'react';
import { Button, Flex, Popconfirm, Tooltip } from 'antd';
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';

interface BalloonReviewActionsProps {
	balloonNumber?: number;
	onApprove: () => void;
	approving: boolean;
	approveDisabled?: boolean;
	approveLabel?: string;
	onDelete?: () => void;
	deleteDisabled?: boolean;
	/** Prefix for the buttons' test ids, e.g. `balloon-review` → `balloon-review-approve`. */
	testIdPrefix: string;
}

/** Approve and Delete for a balloon under review; the same in the review panel and the viewer popup. */
const BalloonReviewActions: React.FC<BalloonReviewActionsProps> = ({
	balloonNumber,
	onApprove,
	approving,
	approveDisabled = false,
	approveLabel = 'Approve',
	onDelete,
	deleteDisabled = false,
	testIdPrefix,
}) => {
	const approve = (
		<Button
			type="primary"
			icon={<CheckOutlined />}
			disabled={approveDisabled}
			loading={approving}
			onClick={onApprove}
			style={{ flex: 1 }}
			data-testid={`${testIdPrefix}-approve`}
		>
			{approveLabel}
		</Button>
	);
	return (
	<Flex gap={8}>
		{approveDisabled ? (
			approve
		) : (
			<Tooltip title="Mark as reviewed. Edits you made are kept; save the project to store them.">
				{approve}
			</Tooltip>
		)}
		{onDelete && (
			<Popconfirm
				title={`Delete balloon ${balloonNumber ?? ''}?`}
				okText="Delete"
				okButtonProps={{ danger: true }}
				disabled={deleteDisabled}
				onConfirm={onDelete}
			>
				<Button
					danger
					icon={<DeleteOutlined />}
					disabled={deleteDisabled}
					data-testid={`${testIdPrefix}-delete`}
				>
					Delete
				</Button>
			</Popconfirm>
		)}
	</Flex>
	);
};

export default BalloonReviewActions;
